<template>
  <!-- 开单 -->
  <div class="page-container">
    <img class="rule-btn" @click="$refs.rulesRef.open()" src="@/static/images/activityCenter/202505/01/gz-btn.png" />
    <div class="main">
      <div class="container">
        <img class="img" src="@/static/images/activityCenter/202505/01/p_01.jpg" />
      </div>

      <div class="container">
        <img class="img" src="@/static/images/activityCenter/202505/01/p_02.jpg" />
      </div>

      <div class="container">
        <img class="img" src="@/static/images/activityCenter/202505/01/p_03.jpg" />
      </div>
      <div class="container">
        <img class="img" src="@/static/images/activityCenter/202505/01/p_04.jpg" />
        <div class="achievement">
          <div class="achievement-text" v-html="performanceText" v-if="!preview && performanceText"></div>
          <div class="achievement-arr"></div>
        </div>
      </div>
      <div class="container">
        <div class="btn" @click="goDetail(0)"></div>
        <img class="img" src="@/static/images/activityCenter/202505/01/p_05.jpg" />
      </div>
      <div class="container">
        <img class="img" src="@/static/images/activityCenter/202505/01/p_06.jpg" />
      </div>
      <div class="container" @click="goProduct('V02C02P009E')">
        <img class="img" src="@/static/images/activityCenter/202505/01/p_07.jpg" />
      </div>
      <div class="container" @click="goProduct('V143C143P001E')">
        <img class="img" src="@/static/images/activityCenter/202505/01/p_08.jpg" />
      </div>
      <div class="container" @click="goProduct('V46C46P002E')">
        <img class="img" src="@/static/images/activityCenter/202505/01/p_09.jpg" />
      </div>
      <div class="container" @click="goProduct('V18C18P003E')">
        <img class="img" src="@/static/images/activityCenter/202505/01/p_10.jpg" />
      </div>
      <div class="container" @click="goProduct('V34C34P001E')">
        <img class="img" src="@/static/images/activityCenter/202505/01/p_11.jpg" />
      </div>
      <div class="container" @click="goProduct('V02C02P008E')">
        <img class="img" src="@/static/images/activityCenter/202505/01/p_12.jpg" />
      </div>
      <div class="container">
        <img class="img" src="@/static/images/activityCenter/202505/01/p_13.jpg" />
        <img class="img" src="@/static/images/activityCenter/202505/01/p_14.jpg" />
      </div>
    </div>

    <!-- 规则 -->
    <activityRules ref="rulesRef" :ruleText="ruleText"></activityRules>
  </div>
</template>

<script>
import config from '@/api/common';
import activityRules from '@/components/okActivity/rulePopup';

export default {
  components: {
    activityRules
  },
  data() {
    return {
      preview: false,
      activityList: [],
      activityIds: [],
      userInfo: JSON.parse(localStorage.getItem('jzy_user')),
      ruleText:
        '<h1 style="text-align:center;font-size: 22px;">规则详情</h1><h2 style="margin-top: 10px;">一、活动时间：</h2><p>2025年5月1日——2025年5月31日</p><p><br/></p><h2><span>二、活动对象：</span></h2><p><span>OK保已签约代理人</span></p><p><br></p><h2><span>三、活动须知：</span></h2><p><span>1、出单活动清单范围内的产品，且累计业绩达到标准。（活动清单会不定期更新，基本覆盖全长险产品）</span></p><p><span>2、业绩计算按照标准保费计算规则:</span></p><p><span>趸交:标准保费=保单保费X0.1</span></p><p><span>交费期限3年期:标准保费=保单保费X0.3</span></p><p><span>交费期限5年期:标准保费=保单保费X0.5</span></p><p><span>交费期限10年期及以上:标准保费=保单保费X1</span></p><p><br></p><h2><span>四、开单阶梯奖</span></h2><h3><span>（一）活动内容</span></h3><p><span>活动期间内出单长险的产品，累计标保满足条件奖励现金。</span></p><p><span>累计标保满2万元奖388元</span></p><p><span>累计标保满5万元奖688元</span></p><p><span>累计标保满10万元奖1088元</span></p><p><span>累计标保满50万元奖2888元</span></p><p><br></p><h3><span>（二）注意事项</span></h3><p><span>对应类别的累计标保排名奖励，以达成的最高门槛对应的奖励进行发放，仅可获得一份奖励。万能险产品不参与此活动，</span><span>新华保险利久久2号终身寿险和中英人寿福临门两全保险A款(互联网)产品不参与此活动。</span></p><p><br></p><h2><span>五、单单奖</span></h2><h3><span>（一）活动内容</span></h3><p><span>出单以下产品，寿险每单首年规模保费大于或者等于5000元，奖励88元，</span></p><p><span>健康险每单首年规模保费大于或者等于3000元，奖励58元，多劳多得。</span></p><p><br></p><p><span>参与单单奖活动产品：</span></p><p><br></p><p><span>新华保险利久久2号终身寿险</span><span>（趸交不参与活动）</span></p><p><span>安联人寿福满满6号养老年金保险（分红型）</span></p><p><span>海保人寿福满满6号养老年金保险</span></p><p><span>中信保诚利多多6号终身寿险（分红型）</span></p><p><span>复兴联合完美7号重大疾病保险（互联网）10年缴费期及以上</span></p><p><span>复星联合妈咪保贝爱常在少儿重大疾病保险（A款）（互联网）</span><span>10年缴费期及以上</span></p><p><br></p><h3><span>（二）注意事项</span></h3><p><span>1、严禁恶意拆单，若发现多笔订单均为同一被保人、投保人、出单人、同一产品，则视为同一个订单，仅发放一次奖励。</span></p><p><span>2、&nbsp;</span><span>单笔订单健康险新单首年</span><span>规模</span><span>保费需满3000元、寿险新单首年</span><span>规模</span><span>保费需满5000元才可获得奖励。</span></p><p><br></p><h2><span>六、活动规则</span></h2><p><span>1、&nbsp;</span><span>如遇退保，OK保将扣回此单所有推广费及所有活动奖励。</span></p><p><span>2、&nbsp;</span><span>如发现同一代理人活动期间退保率超过10%，OK保有权追回所有奖励。</span></p><p><span>3、&nbsp;</span><span>活动订单仅计算活动期间所出新单，不含追加、加保、续期订单。</span></p><p><span>4、&nbsp;</span><span>投保时间和承保时间都需要在活动期间内，在活动结束次月20日24点前成功通过质检、且签收回执、保单过犹过访，满足以上所有条件方可计入活动业绩。</span></p><p><span>5、代理人奖励发放时，需满足平台业务品质要求。如不满足，平台有权不予发放奖励。OK保有权对业绩品质进行质检。</span></p><p><span>6、参加活动要求个人继续率</span><span>≥</span><span>90%，且个人新单退保率&lt;5%，达标与否，将以活动开始前定版数据&nbsp;(即2025.4.30日零点系统数据)&nbsp;为准。</span></p><p><span>7、代理人若在奖励发放前离职或停职或</span><span>账号已注销，</span><span>则奖励不予结算。</span></p><p><br></p><h2><span>七、活动奖励发放</span></h2><p><span>1、奖励将会在活动结束后的次月20日之后进行发放。产生退保的订单奖励不予结算。领取途径：进入APP我的页面——点击可提现——提现到银行卡。</span></p><p><span>2、&nbsp;</span><span>退保的情况下，业绩数据同步会有延迟，以活动结束后的最终核算业绩（扣除退保件等）为主，来进行活动奖励发放。</span></p><p><br></p><h2><span>八、活动参与资格、获奖资格的取消</span></h2><p><span>本活动严禁一切不正当手段和舞弊行为，用户若有下列任何一种行为或情况的，OK保有权单方面取消异常用户的活动参与资格、所有奖励获奖资格。</span></p><p><span>1、不符合活动参与资格的，提供虚假个人信息和邀请信息参与活动，进行虚假注册、签约和交易的。</span></p><p><span>2、恶意破坏活动，以任何机器人软件、蜘蛛软件、爬虫软件、刷奖软件或其它任何自动方式、不正当手段等参与本活动的。</span></p><p><span>3、&nbsp;</span><span>违反诚实信用、公序良俗、公平、公正等原则行为，违反相关法规、本活动规则行为。</span></p><p><span>4、&nbsp;</span><span>自保件及互保件不享受活动奖励。</span></p><p><span>5、专项推动方案、限时活动奖励、临时加费、调档产品、一单一议等产品不享受活动奖励和基本法奖。</span></p><h2><span>九、免责条款</span></h2><p><span>互联网运行存在诸多不确定性因素，如因不可抗力、网络、通讯线路故障、计算机大规模瘫痪及活动中存在大面积作弊行为等原因致使本活动出现异常情况或难以继续开展的，OK保有权采取包括但不限于通过各种方式消除异常情况或调整、暂停、取消本活动等合理措施保障OK保及用户的合法权益，您表示理解，由此给您造成的损失，您同意不追究OK保的责任。</span></p><p><br></p><p><span>以上奖励条件以系统记录为准，若出现刷量或恶意投诉，OK保将保留追究法律责任的权利。本活动最终解释权归梧桐树保险经纪有限公司所有。</span></p><p><br></p>',
      performanceText: ``
    };
  },

  created() {
    this.preview = this.$route.query.preview ? true : false;
    if (this.$route.query.preview) return;
    // 地址栏配置id
    let ids = this.$route.query.ids;
    if (ids) {
      this.activityIds = ids.split(',');
    } else if (config.env == '0' || config.env == '2') {
      // 本地、测试
      this.activityIds = ['1905061079457730562'];
    } else {
      // 正式
      this.activityIds = ['1917049273965142018'];
    }
    this.getActivityList();
    this.getPerformance();
  },

  methods: {
    // 去出单
    goProduct(productCode) {
      if (this.preview) return;
      let url = '';
      if (config.env == '0' || config.env == '2') {
        url = `https://fqjdstore.wts9999.net/m/product/app/${this.userInfo.userId}/${productCode}`;
      } else {
        url = `https://jdstore.fxyf99.com/m/product/app/${this.userInfo.userId}/${productCode}`;
      }
      this.$app.openWeb(url);
    },
    // 获取活动详情
    getActivityList() {
      this.$http({
        type: 'GET',
        url: '/app/merchantActivity/detailList',
        data: {
          idList: this.activityIds.join(',')
        }
      }).then(res => {
        this.activityList = res.data;
      });
    },

    // 开单绩效
    getPerformance() {
      this.$http({
        type: 'GET',
        url: '/api/okbAct/actLotteryPolicyLog/queryActPolicyAmount',
        data: {
          activityId: this.activityIds[0]
        }
      }).then(res => {
        if (res.data.amount >= 0 && res.data.amount < 20000) {
          const money = (20000).sub(res.data.amount).toFixed(2);
          this.performanceText = `活动业绩<span class="text1">${res.data.amount}元</span>，还差<span class="text1">${money}元</span>可获得<span class="text1">388元</span>`;
        } else if (res.data.amount >= 20000 && res.data.amount < 50000) {
          const money = (50000).sub(res.data.amount).toFixed(2);
          this.performanceText = `活动业绩<span class="text1">${res.data.amount}元</span>，还差<span class="text1">${money}元</span>可获得<span class="text1">688元</span>`;
        } else if (res.data.amount >= 50000 && res.data.amount < 100000) {
          const money = (100000).sub(res.data.amount).toFixed(2);
          this.performanceText = `活动业绩<span class="text1">${res.data.amount}元</span>，还差<span class="text1">${money}元</span>可获得<span class="text1">1088元</span>`;
        } else if (res.data.amount >= 100000 && res.data.amount < 500000) {
          const money = (500000).sub(res.data.amount).toFixed(2);
          this.performanceText = `活动业绩<span class="text1">${res.data.amount}元</span>，还差<span class="text1">${money}元</span>可获得<span class="text1">2888元</span>`;
        } else {
          this.performanceText = `活动业绩<span class="text1">${res.data.amount}元</span>，可获得<span class="text1">2888元</span>`;
        }
      });
    },
    // 参与详情
    goDetail(index) {
      if (this.preview) return;
      this.$router.push({
        path: '/apps/partakeList',
        query: {
          id: this.activityIds[index],
          type: this.activityList[index].type,
          calFactor: this.activityList[index].calFactor,
          productType: this.activityList[index].productType,
          mode: this.activityList[index].mode,
          status: this.activityList[index].status,
          conditionalIndicator: this.activityList[index].conditionalIndicator
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  .rule-btn {
    width: 77px;
    height: 77px;
    position: fixed;
    right: 20px;
    top: 500px;
    z-index: 2;
  }
  .main {
    height: 100vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .container {
    position: relative;
    .img {
      width: 750px;
      display: block;
    }
    
    /deep/ .achievement {
      position: absolute;
      top: 0;
      left: 50px;
      text-align: center;
      background: transparent;
      padding: 6px 20px;
      line-height: 1;
      white-space: nowrap;
      border-radius: 15px;
      background: #1b9c55;
      .achievement-text {
        color: #fff;
        font-size: 24px;
        position: relative;
        z-index: 2;
      }
      .achievement-arr {
        content: '';
        position: absolute;
        left: 0;
        bottom: -20px;
        z-index: 1;
        width: 0;
        height: 0;
        border-color: #1b9c55;
        border-style: solid;
        border-width: 20px;
        border-right-color: transparent;
        border-bottom-color: transparent;
      }

      .text1 {
        color: #ffe59c;
      }
    }
    .status1 {
      position: absolute;
      width: 595px;
      left: 0;
      right: 0;
      top: 240px;
      margin: auto;
    }
  }
  .btn {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    width: 360px;
    height: 100px;
  }

  .go-order-btn {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0px;
    width: 320px;
    height: 105px;
    left: 50%;
    margin-left: -150px;
    border-radius: 55px;
  }
}
</style>
